<template>
  <div>
    <data-table :service="service"
                :entity="entity"
                :columns="columns"
                :filters="filters"
                operations="refresh"
                :go-to-details-on-row-click="false"
                ref="table">

      <template slot="extra-filter-buttons">
        <base-dropdown position="right">
          <base-button slot="title"
                       icon
                       outline
                       type="primary">
            <i class="nc-icon nc-settings-gear-65"></i>
          </base-button>
          <h6 class="dropdown-header">{{$t('generic.settings')}}</h6>
          <div class="dropdown-item" @click="exportInvoiceLines">
            {{$t('generic.exportToCSV')}}
          </div>

        </base-dropdown>
      </template>

      <template v-slot:client_name="{row}">
        <router-link class="font-bold" :to="`/contacts/clients/${row.client_uuid}`">
          {{row.client.name}}
        </router-link>
      </template>

      <template v-slot:invoice="{row}">
        <template v-if="row.invoice">
         <div class="flex items-center">
           <status-badge class="mr-3" :status="row.invoice.status"/>
           <router-link class="font-bold" :to="`/ecommerce/invoices/${row.invoice.uuid}`">
             {{row.invoice.name || 'N/A'}}
           </router-link>
         </div>
        </template>
        <template v-else>
          - -
        </template>
      </template>

      <div class="flex flex-column" slot="price_ex" slot-scope="{row}">
        <div>
          {{parseFloat(row.price_ex) | toCurrency}}
          <small>{{$t('generic.exclVAT')}}</small>
        </div>
        <div class="mt-1">
          {{parseFloat(row.price_in) | toCurrency}}
          <small>{{$t('generic.inclVAT')}}</small>
        </div>
      </div>

      <template slot="created_at" slot-scope="{row}">
        {{$formatDate(row.created_at, FRIENDLY_DATETIME_FORMAT)}}
      </template>
    </data-table>
  </div>
</template>
<script>
  import enitites from 'src/config/entities'
  import InvoiceLinesService from 'src/services/InvoiceLinesService'
  import { FRIENDLY_DATETIME_FORMAT } from 'src/config/dateUtils'

  export default {
    name: 'invoice-lines',
    data () {
      return {
        entity: enitites.INVOICE_LINE,
        service: InvoiceLinesService,
        FRIENDLY_DATETIME_FORMAT,
        filterDate: new Date()
      }
    },
    computed: {
      columns () {
        return [
          {
            prop: 'client_name',
            label: this.$t('invoiceLines.list.labels.client'),
            minWidth: '150px',
            sortable: true
          },
          {
            prop: 'invoice',
            label: this.$t('invoiceLines.list.labels.invoice'),
            minWidth: '160px',
            sortable: true
          },
          {
            prop: 'price_ex',
            label: this.$t('invoiceLines.list.labels.priceEx'),
            minWidth: '190px',
            sortable: true
          },
          {
            prop: 'created_at',
            label: this.$t('generic.createdAt'),
            minWidth: '175px',
            sortable: true
          },
        ]
      },
      filters() {
        return [
          {
            key: 'with',
            value: 'client,invoice'
          }
        ]
      }
    },
    methods: {
      async exportInvoiceLines() {
        await InvoiceLinesService.export()
      }
    }
  }
</script>
<style>
</style>
